import { Filter } from '@itonics/filters';
import { FilterQuery, SortOption } from '../interfaces/feed';

export class FilterQueryBuilder {
  private filterQuery: FilterQuery = { highlight: false, aggregations: [] };

  public aggregations(aggregations: Array<string>): FilterQueryBuilder {
    if (aggregations) {
      this.filterQuery.aggregations = aggregations;
    }

    return this;
  }

  public setSearchField(searchFieldUri: string): FilterQueryBuilder {
    if (searchFieldUri) {
      this.filterQuery.searchFieldUri = searchFieldUri;
    }
    return this;
  }

  public query(filter: Filter): FilterQueryBuilder {
    if (filter) {
      this.filterQuery.query = filter.toJson(true);
    }

    return this;
  }

  public sort(sort: SortOption): FilterQueryBuilder {
    if (sort) {
      this.filterQuery.sortBy = sort.sortBy;
      this.filterQuery.sortOrder = sort.sortOrder;
    }

    return this;
  }

  public paginationCursor(paginationCursor: any): FilterQueryBuilder {
    if (paginationCursor) {
      this.filterQuery.paginationCursor = JSON.stringify(paginationCursor);
    }

    return this;
  }

  public limit(limit: number): FilterQueryBuilder {
    if (limit) {
      this.filterQuery.limit = limit;
    }

    return this;
  }

  public highlight(highlight: boolean): FilterQueryBuilder {
    this.filterQuery.highlight = highlight;

    return this;
  }

  public build(): FilterQuery {
    return this.filterQuery;
  }
}
